import styled from '@emotion/styled';
import { Typography } from '@innovamat/glimmer-components';

export const StyledBody = styled(Typography.Body2)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
  white-space: pre-line;
`;

export const StyledSubtitle = styled(Typography.Subtitle2)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
`;
